import { Component, Prop, h, Element } from '@stencil/core';

/** The `pn-text-link` is a styled `a` element with some extra functionality built in. Such as `icon` and `light` support.  */
@Component({
  tag: 'pn-text-link',
  styleUrl: 'pn-text-link.scss',
})
export class PnTextLink {
  @Element() hostElement: HTMLElement;

  /** The link text. */
  @Prop() label?: string;
  /** The URL string. */
  @Prop() href!: string;

  /** Use the light version of the link. @category Visual */
  @Prop() light: boolean = false;
  /** SVG content of the icon. @category Visual */
  @Prop() icon?: string;
  /** Align the icon on the left. @category Visual */
  @Prop() leftIcon: boolean = false;

  /** Treat the link as a download link. @category Link attributes */
  @Prop() download?: string;
  /** Set the hreflang of the URL destination. @category Link attributes */
  @Prop() hreflang?: string;
  /** Link media. @category Link attributes */
  @Prop() media?: string;
  /** Set referrerpolicy on the link. @category Link attributes */
  @Prop() referrerpolicy?: ReferrerPolicy;
  /** Set the rel of the link. @category Link attributes */
  @Prop() rel: string = 'noopener noreferrer';
  /** Set the target of the link. @category Link attributes */
  @Prop() target?: string;
  /** Set a unique html ID of the a element. @category Link attributes */
  @Prop() linkid?: string;

  render() {
    return (
      <a
        id={this.linkid}
        class="pn-text-link"
        href={this.href}
        rel={this.rel}
        target={this.target}
        download={this.download}
        hreflang={this.hreflang}
        media={this.media}
        referrerPolicy={this.referrerpolicy}
        data-icon={!!this.icon}
        data-icon-left={this.leftIcon}
        data-light={this.light}
      >
        {this.label}
        <slot></slot>
        {this.icon && <pn-icon icon={this.icon} />}
      </a>
    );
  }
}
